import { render, staticRenderFns } from "./WorkGenericPicker.vue?vue&type=template&id=19d3660e"
import script from "./WorkGenericPicker.vue?vue&type=script&lang=js"
export * from "./WorkGenericPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports